import notificationApi from '@/api/notification'

const state = () => ({
  all: [],
  allWidget: [],
  notification: {},
  read: null,
  readAll: null,
  deleted: null
})

const getters = {}

const actions = {
  async getNotifications ({ commit }, params) {
    const result = await notificationApi.getAll(params)
    commit('setNotifications', result.data)
  },

  async getNotificationsWidget ({ commit }, params) {
    const result = await notificationApi.getAll(params)
    commit('setNotificationsWidget', result.data)
  },

  async getNotification ({ commit }, id) {
    const result = await notificationApi.getOne(id)
    commit('setNotification', result.data)
  },

  async markAsRead ({ commit }, id) {
    const result = await notificationApi.markAsRead(id)
    commit('setNotificationRead', result.data)
  },

  async markAllAsRead ({ commit }) {
    const result = await notificationApi.markAllAsRead()
    commit('setNotificationReadAll', result.data)
  },

  async erase ({ commit }, id) {
    const result = await notificationApi.erase(id)
    commit('setNotificationDeleted', result.data)
  },
}

const mutations = {
  setNotifications (state, notifications) {
    state.all = notifications
  },
  setNotificationsWidget (state, notifications) {
    state.allWidget = notifications
  },
  setNotification (state, result) {
    state.notification = result
  },
  setNotificationRead (state, result) {
    state.read = result
  },
  setNotificationReadAll (state, result) {
    state.readAll = result
  },
  setNotificationDeleted (state, result) {
    state.deleted = result
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
